<template>
  <section class="app-main" :class="{ 'business-main': isBusinessView }">
    <router-view v-slot="{ Component, route }">
      <template v-if="Component && !route.meta.link">
        <transition
          :name="isBusinessView ? undefined : 'fade-transform'"
          :mode="isBusinessView ? undefined : 'out-in'"
        >
          <keep-alive :include="tagsViewStore.cachedViews">
            <component
              :is="Component"
              :key="route.fullPath"
            />
          </keep-alive>
        </transition>
      </template>
    </router-view>
    <iframe-toggle />
  </section>
</template>

<script setup>
import iframeToggle from "./IframeToggle/index";
import useTagsViewStore from "@/store/modules/tagsView";
import { isBusinessRoute } from '@/utils/businessView';

const route = useRoute();
const tagsViewStore = useTagsViewStore();
const isBusinessView = computed(() => isBusinessRoute(route));

watch(isBusinessView, (value) => {
  document.body.classList.toggle('business-route', value);
}, { immediate: true });

onMounted(() => {
  addIframe();
});

onBeforeUnmount(() => {
  document.body.classList.remove('business-route');
});

watchEffect((route) => {
  addIframe();
});

function addIframe() {
  if (route.meta.link) {
    useTagsViewStore().addIframeView(route);
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.module.scss";
.app-main {
  /* 50= navbar  50  */
  // min-height: calc(100vh - 50px);
  // height: auto !important;
  width: calc(100% - 1.2rem);
  position: relative;
  overflow: hidden;
  margin-top: 0;
  // margin-left: $base-sidebar-width;
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    // min-height: calc(100vh - 12.5rem);
    // height: calc(100vh - 12.5rem);
    min-height: 85vh;
    height: auto;
    overflow-y: auto;
  }

  // .fixed-header + .app-main {
  //   padding-top: 5.25rem;
  // }
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 6px;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
.pagination-container .el-select__wrapper.is-focused {
  box-shadow: 0 0 0 1px #ff830e inset;
}
.pagination-container .el-pagination.is-background .btn-next,
.pagination-container .el-pagination.is-background .btn-prev,
.pagination-container .el-pagination.is-background .el-pager li {
  color: #ff830e;
  background-color: #fff;
  border: #ff830e solid 1px;
}

.pagination-container .el-pagination.is-background .btn-next.is-active,
.pagination-container .el-pagination.is-background .btn-prev.is-active,
.pagination-container .el-pagination.is-background .el-pager li.is-active {
  background-color: #ff830e !important;
  color: #fff;
}
.el-popper
  .el-select-dropdown
  .el-scrollbar
  .el-select-dropdown__wrap
  .el-select-dropdown__list
  .el-select-dropdown__item.is-selected {
  color: #ff830e !important;
}
</style>

